import Api from "@/services/Api";
import axios from "axios";

export default {
	async all() {
		const hadsShard    = Api().get("/tls/groups", { params: { storechain: "tls-app-hads" } });
		const defaultShard = Api().get("/tls/groups", { params: { storechain: "tls-app-default" } });

		return axios.all([hadsShard, defaultShard])
			.then(axios.spread((...responses) => responses.map(response => response.data)))
			.catch(error => Promise.reject(error));
	},

	async find(groupId) {
		return Api().get(`/tls/groups/${groupId}`, {
			params: {
				group_id: groupId,
			}
		}).then(response => response.data)
			.catch(error => Promise.reject(error));
	},

	async getPros(groupId) {
		return Api().get("/tls/groups/pros", {
			params: {
				group_id: groupId
			}
		}).then(response => response.data)
			.catch(error => Promise.reject(error));
	},

	async getInstructions(groupId) {
		return Api().get("/tls/groups/instructions", {
			params: {
				group_id: groupId,
			}
		}).then(response => response.data)
			.catch(error => Promise.reject(error));
	},
};
